document.addEventListener('DOMContentLoaded', () => {
  // Sliderの初期化
  const productThumbs = new Swiper('.product-thumbs', {
    spaceBetween: 6,
    slidesPerView: 6,
    grid: {
      rows: 3, // your amount of slides
      fill: 'row',
    },
  });
  const productSlider = new Swiper('.product-slider', {
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    resizeObserver: true,
    thumbs: {
      swiper: productThumbs,
    },
  });
  $(window).on('resize', function () {
    setTimeout(() => {
      productThumbs.update();
      productSlider.update();
    }, 0);
  });

  // 初期更新を遅延実行
  setTimeout(() => {
    $(window).trigger('resize');
  }, 100);
});
// productSlider.controller.control = productThumbs;
// productThumbs.controller.control = productSlider;
